import { combineReducers } from "redux";
import ticketDetail from "./ticketDetail";
import { ticketsReducer as ticketsList } from "./ticketList/ticketListSlice";
import { ticketMessagesReducer } from "./ticketMessages/ticketMessagesReducer";
import { reducer as queue } from "./ticketQueue/ticketQueueSlice";
import { reducer as readTicketsIds } from "./ticketsRead/ticketsReadActions";

export default combineReducers({
  ticketDetail,
  ticketsMessagesReducer: ticketMessagesReducer,
  ticketsList,
  queue,
  readTicketsIds,
});
